import App from '../../../vendor_core/core/src/App';
import { Commands } from '../../../vendor_core/core/src/commands/CommandEnum';
import CommandManager from '../../../vendor_core/core/src/commands/CommandManager';
import { ConfigurationTypes } from '../../../vendor_core/core/src/const/ConfigurationTypes';
import GameEvents from '../../../vendor_core/core/src/const/GameEvents';
import PointerEvents from '../../../vendor_core/core/src/const/PointerEvents';
import SoundVars from '../../../vendor_core/core/src/const/SoundVars';
import { Ease } from '../../../vendor_core/core/src/Ease';
import ConfigManager from '../../../vendor_core/core/src/managers/ConfigManager';
import GameModel from '../../../vendor_core/core/src/model/GameModel';
import SpinModel from '../../../vendor_core/core/src/model/SpinModel';
import GenericBigWinState from '../../../vendor_core/core/src/states/GenericBigWinState';
import StateMachine from '../../../vendor_core/core/src/states/StateMachine';
import { Tween } from '../../../vendor_core/core/src/Tween';
import BangUp from '../../../vendor_core/core/src/utils/BangUp';
import KeyboardManager, { Key } from '../../../vendor_core/core/src/utils/KeyboardManager';
import { DefaultLayers } from '../../../vendor_core/core/src/utils/Layers';
import PromiseHelpers from '../../../vendor_core/core/src/utils/PromiseHelpers';
import SoundController from '../../../vendor_core/core/src/utils/SoundController';
import ViewManager from '../../../vendor_core/core/src/utils/ViewManager';
import { AbstractBitmapMoneyField } from '../../../vendor_core/core/src/views/AbstractBitmapMoneyField';
import { AbstractMoneyField } from '../../../vendor_core/core/src/views/AbstractMoneyField';
import SpineAnimation from '../../../vendor_core/core/src/views/SpineAnimation';
import GameSoundVars from '../enums/GameSoundVars';
import GameGeneralConfig from '../../configs/GameGeneralConfig';

export default class TRWBigWinState extends GenericBigWinState {

    protected readonly bwNames = [ "bigwin_loop", "superwin_loop", "megawin_loop", "epicwin_loop" ];
    protected anim: SpineAnimation;
    private winMusic: Howl;
    private counWinSound: Howl;

    public setBigWinConfig() {
        this.bigWinsDelayConfig = GameModel.gameConfig.bigWinsDelayConfig;
    }

    public async startBigWin(): Promise<void> {

        ViewManager.getLayer(DefaultLayers.SplashOverlay).setScene("open");
        this.backgroundScene = this.backgroundLayer.setScene("bigWin");
        let bwBitmapText = this.scene.sceneTextFields.get("win");
        const winMoney = this.scene.sceneMoneyFields.get("win_counter");

        bwBitmapText.visible = false;
        winMoney.visible = false;

        this.anim = this.backgroundScene.spineAnimations.get("bigWin");
        this.playAnimation(this.bwNames[this.currentBigWinLevel]);
        this.bigWinAnimComplete = false;
        this.bwBitmapText = this.scene.sceneTextFields.get("win");
        this.bwBitmapText.text = "";
        this.playTransitionSound();
        let bangupEndVal = this.getSum();
        this.currentBangup = new BangUp();
        let bigWinDuration = this.bigWinsDelayConfig[this.bigWinScenes[this.currentBigWinLevel]].bigWinDuration;
        let bigWinBangupDuration = this.bigWinsDelayConfig[this.bigWinScenes[this.currentBigWinLevel]].bigWinBangupDuration;

        this.bigWinAnimDelayed = Tween.delayedCall(bigWinDuration, this.onBigWinAnimationComplete, [], this);
        winMoney.value = 0;
        this.currentBangup.startBangup(this.bangUpVal, bangupEndVal, bigWinBangupDuration, {ease: Ease.None}, (val) => {
            this.bangUpVal = val;
            winMoney.value = this.bangUpVal;
            }, () => {
                this.onBigWinBangupComplete();
            }
        );

        // SoundController.playSound(GameSoundVars.BIG_WIN_COINS, true);
        SoundController.playSound("bigWinZoomIn");

        // this.popupMoney(winMoney, bigWinBangupDuration);
        this._canExit = true;
        bwBitmapText.visible = true;
        winMoney.visible = true;


        this.counWinSound = SoundController.playSound(SoundVars.EFFECT_WINCOUNT, true);

        if (this.currentBigWinLevel == 0) {
            this.winMusic = SoundController.playSound(GameSoundVars.BIG_WIN, true);
        }
    }

    private popupMoney(
        money: AbstractMoneyField | AbstractBitmapMoneyField,
        duration: number
    ): Promise<boolean> {
        money.visible = true;
        let w = money.width;
        let h = money.height;
        let x = money.x;
        let y = money.y;
        return new Promise<boolean>((res) => {
            Tween.to(
                money,
                0.3,
                {
                    width: money.width * 1.3,
                    height: money.height * 1.3,
                    x: x - ((w * 1.3 - w) / 2),
                    yoyo: true,
                    repeat: 1,
                    onComplete: () => {
                        res(true);
                        this.startGrowUp(money, duration);
                    }
                }
            )
        })
    }

    private startGrowUp(
        money: AbstractMoneyField | AbstractBitmapMoneyField,
        duration: number) {
        //---------start banner grow up-------
        let w = money.width;
        let h = money.height;
        let x = money.x;
        let y = money.y;

        Tween.to(
            money,
            duration,
            {
                width: w * 1.1,
                height: h * 1.1,
                x: x - ((w * 1.1 - w) / 2),
                ease: Ease.None,
            }
        );
    }

    public playCollectSound(): void {
        // do not delete
    }

    private playAnimation( animName: string ): Promise<boolean>
    {
        return new Promise((res) => {
            this.anim.play(animName);
            Tween.delayedCall(this.anim.getAnimDuration(animName), () => res(), [], this);
        });
    }

    public skip(): void {

        const elapsedSeconds = (new Date().getTime() - (<any>StateMachine.currentState).timer) / 1000;

        // if(elapsedSeconds <= ConfigManager.getConfig<typeof GameGeneralConfig>(ConfigurationTypes.GAME).minWatchTime) {
        //     return;
        // }

        super.skip();

        if(this.bigWinAnimDelayed) {
            this.bigWinAnimDelayed.kill();
        }
        if(!this.bigWinAnimComplete) {
            this.onBigWinAnimationComplete();
        }
    }

    protected async onBigWinBangupComplete(): Promise<void> {
        if(this.counWinSound) {
            SoundController.fadeStop(this.counWinSound, 0.5);
        }

        // dirty hack; TODO: fix maxBigWinLevel
        const maxBigWinLevel: number = this.skipped ? this.maxBigWinLevel : this.maxBigWinLevel + 1

        if(this.currentBigWinLevel == maxBigWinLevel || this.maxBigWinLevel == 0) {
            if(this.winMusic) {
                SoundController.fadeStop(this.winMusic, 0.3);
                SoundController.playSound("bigWinsSumHit");
                Tween.delayedCall(0.2, () => SoundController.playSound(SoundVars.BIG_WIN_COMPLETE));
                this.winMusic = undefined;
            }
        } else {
            SoundController.playSound("bigWinZoomOut");
        }

        // SoundController.stopSound(GameSoundVars.BIG_WIN_COINS);
    }

    protected async onBigWinAnimationComplete(): Promise<void> {
        if(!this.canExit()) {  // if skip was activated
            if(this.winMusic) {  // if onBigWinBangupComplete is not finished
                this.onBigWinBangupComplete();
            }
        }

        if (this.skipped) {
            const winMoney = this.scene.sceneMoneyFields.get("win_counter");
            winMoney.value = this.getSum();
            await this.anim.playAsync(this.bwNames[this.maxBigWinLevel], undefined, undefined, 2);
        }

        super.onBigWinAnimationComplete();
        this.scene.sceneTextFields.get("win").text = "";
    }

    protected async onBigWinComplete() {
        SoundController.playSound("bigWinZoomOut");
        await this.anim.playAsync(this.bwNames[this.maxBigWinLevel].replace("_loop", "_end"));
        this._canExit = false;
        if (this.coinAnimation) {
            this.coinAnimation.destroy();
            this.coinAnimation = null;
        }
        this.scene = null;
        this.currentBigWinLevel = 0;
        this.maxBigWinLevel = 0;
        this.bangUpVal = 0;
        this.layer.completeClear();
        this.backgroundLayer.off(PointerEvents.DOWN, this.skipWithKey, this);
        this.backgroundLayer.completeClear();
        KeyboardManager.offKey("pressed", Key.SPACE, this.skipWithKey , this);
        App.dispatcher.emit(GameEvents.SHOW_BIG_WIN_COMPLETE);

        ViewManager.getLayer(DefaultLayers.SplashOverlay).clear();
        this.exit();
    }
}
